import React from "react";
import axios from "axios";
import validator from 'validator';
import { notifications } from '@mantine/notifications';
import { Box, Group, Drawer, Button, Text, ActionIcon } from '@mantine/core';
import { IconArrowLeft } from '@tabler/icons-react';

import { useLoginContext } from "../../context/loginContext";
import { BE_API_ONE, utils } from "../../utils/globalVariables";

import InputComponent from "../../components/general/InputComponent";
import ModalResponse from "../../components/general/ModalResponse";

const CustomerGroupAdd = ({ stateShow, fnShow, fnSuccessAdd }) => {

    const mountedRef = React.useRef(true);
    const { loginContext, handleSetLoginContext } = useLoginContext();

    const notificationId = React.useRef({
        errorSubmitData: 'CustomerGroupAdd-1',
        successSubmitData: 'CustomerGroupAdd-2',
    })

    const constCustGroupName = {
        id: 'addCustGroupName',
        label: 'Nama Group',
        withAsterisk: true,
        placeholder: 'Nama Group',
        value: '',
        description: 'Contoh: Maranatha - Dosen',
        error: ''
    }

    const [data, setData] = React.useState({
        name: constCustGroupName,

        submitLoading: false,

        modalResponse: {
            show: false,
            type: utils.modalResponse.warning,
            hideOnClickOutSide: false,
            content: ''
        }
    });

    React.useEffect(() => {
        return () => {
            mountedRef.current = false;
        }
    }, [])

    const resetData = () => {
        setData(d => ({ ...d, name: constCustGroupName }))
    }

    const addData = () => {
        setData(d => ({ ...d, name: { ...d.name, error: '' } }));

        if (validator.isEmpty(data.name.value, { ignore_whitespace: true })) {
            setData(d => ({ ...d, name: { ...d.name, error: 'Kolom wajib diisi!', } }));
        } else {

            setData(d => ({ ...d, submitLoading: true }));

            const formDT = new FormData();
            const formDTHeader = { 'Content-Type': 'application/json' }

            formDT.append('json_token', loginContext.syswebapp);
            formDT.append('name', data.name.value);

            axios({
                method: 'post',
                url: BE_API_ONE + '/customer_group_add',
                data: formDT,
                headers: formDTHeader,
            }).then((response) => {
                if (!mountedRef.current) return null;

                setData(d => ({ ...d, submitLoading: false }));

                if (response.data.flag_status === 'isset') {

                    resetData();
                    fnSuccessAdd();

                    notifications.show({
                        id: notificationId.current.successSubmitData,
                        title: utils.notification.success.caption,
                        message: 'Berhasil Tambah Data.',
                        color: utils.notification.success.color,
                        icon: utils.notification.success.icon,
                        withBorder: true,
                        autoClose: true,
                    })
                }

                if (response.data.flag_status === 'error') {
                    notifications.show({
                        id: notificationId.current.errorSubmitData,
                        title: utils.notification.warning.caption,
                        message: response.data.pesan,
                        color: utils.notification.warning.color,
                        icon: utils.notification.warning.icon,
                        withBorder: true,
                        autoClose: true,
                    })
                }

                if (response.data.flag_status === 'duplicate-name') {
                    setData(d => ({
                        ...d,
                        modalResponse: {
                            ...d.modalResponse,
                            type: utils.modalResponse.warning,
                            hideOnClickOutSide: false,
                            content: `Nama group "${response.data.suspect}" sudah pernah digunakan.`,
                            show: true
                        }
                    }))
                }

                if (response.data.flag_status === 'invalid-json-token') {
                    handleSetLoginContext(null);
                }

                if (response.data.flag_status === 'user-inactive') {
                    handleSetLoginContext(null);
                }
            }).catch(error => {
                if (!mountedRef.current) return null;

                setData(d => ({ ...d, submitLoading: false }));

                notifications.show({
                    id: notificationId.current.errorSubmitData,
                    title: utils.notification.warning.caption,
                    message: error.message,
                    color: utils.notification.warning.color,
                    icon: utils.notification.warning.icon,
                    withBorder: true,
                    autoClose: false,
                })
            })
        }
    }

    return (
        <React.Fragment>
            <Drawer
                opened={stateShow}
                onClose={fnShow}
                withCloseButton={false}
                position="left"
                closeOnClickOutside={true}

                title={
                    <Group noWrap spacing='xs'>
                        <ActionIcon
                            size='lg'
                            variant="light"
                            radius='xl'
                            color="blue"
                            onClick={fnShow}
                        >
                            <IconArrowLeft size='1.25rem' stroke={1.5} />
                        </ActionIcon>

                        <Text>Tambah Group Customer</Text>
                    </Group>
                }
                size='md'

                styles={() => ({
                    title: {
                        fontWeight: 'bold',
                        textTransform: 'uppercase'
                    }
                })}
            >
                <Box py='md'>

                    <Box mb='2rem'>
                        <InputComponent
                            stateId={data.name.id}
                            stateWithAsterisk={data.name.withAsterisk}
                            stateLabel={data.name.label}
                            stateDescription={data.name.description}
                            statePlaceHolder={data.name.placeholder}
                            stateValue={data.name.value}
                            stateError={data.name.error}

                            fnOnChange={(e) => setData(d => ({
                                ...d,
                                name: {
                                    ...d.name,
                                    value: e.target.value
                                }
                            }))}
                        />
                    </Box>

                    <Group position="apart" noWrap spacing='xs' my='xl'>
                        <Button
                            fullWidth
                            variant="default"
                            color='gray'
                            onClick={resetData}
                        >
                            Reset
                        </Button>

                        <Button
                            fullWidth
                            // variant="default"
                            // color='teal'
                            loading={data.submitLoading}
                            onClick={addData}
                        >
                            Submit
                        </Button>
                    </Group>
                </Box>
            </Drawer>

            <ModalResponse
                stateShow={data.modalResponse.show}
                fnHide={() => setData(d => ({
                    ...d,
                    modalResponse: {
                        ...d.modalResponse,
                        show: false
                    }
                }))}

                stateHideOnClickOutSide={data.modalResponse.hideOnClickOutSide}
                stateType={data.modalResponse.type}
                stateContent={data.modalResponse.content}
            />

        </React.Fragment>
    )
}

export default CustomerGroupAdd;